// extracted by mini-css-extract-plugin
module.exports = {"alert":"alerts_alert__3ueO8","alert-icon":"alerts_alert-icon__2D42-","alert-dismiss":"alerts_alert-dismiss__2bZgt"};